import React from 'react';

import { Button, Icon } from '@/ui-kit';

import { TitleWithWbr } from '../../components/domain/common/TitleWithWbr';

import './GroupTitle.scss';

type GroupTitleProps = {
  title: string;
  subtitle?: string;
  minRequiredHint?: string;
  hasDelete?: boolean;
  isCollapsible?: boolean;
  isCollapsed?: boolean;
  allowRemove?: boolean;
  onCollapse?: React.MouseEventHandler<HTMLButtonElement>;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
};

export const GroupTitle: React.FC<GroupTitleProps> = ({
  title,
  subtitle,
  minRequiredHint,
  hasDelete = false,
  isCollapsible = false,
  isCollapsed = false,
  onCollapse,
  onDelete,
  allowRemove = false,
}) => {
  return (
    <div className="gt__container">
      <div className="gt__title-container">
        <h3 className="gt__title">
          <TitleWithWbr>{title}</TitleWithWbr>
        </h3>
        {subtitle && subtitle !== '' && (
          <h5 className="gt__subtitle">{subtitle}</h5>
        )}
        {minRequiredHint && (
          <span className="gt__min-hint">{minRequiredHint}</span>
        )}
      </div>
      <hr className="gt__separator" />
      {hasDelete && allowRemove && !isCollapsed && (
        <Button
          className="gt__delete-button"
          aria-label={`Remove ${title}`}
          variant="tertiary"
          kind="muted"
          size="small"
          type="button"
          onClick={onDelete}
          leadingIcon={<Icon size="large" type="trash" />}
        />
      )}
      {isCollapsible && (
        <Button
          aria-label={`${isCollapsed ? 'Expand' : 'Collapse'} ${title}`}
          aria-expanded={!isCollapsed}
          variant="tertiary"
          kind="default"
          size="small"
          type="button"
          onClick={onCollapse}
          leadingIcon={
            <Icon size="large" type={isCollapsed ? 'arrow-down' : 'arrow-up'} />
          }
        />
      )}
    </div>
  );
};
